module.exports = __webpack_public_path__ + "static/media/2-funds.e4189013.svg";